import type { CmsPage } from '@core-types/cms';

export const mergeContentPages = (page1: CmsPage[], page2: CmsPage[]): CmsPage[] => ([...page1, ...page2]);

export const createLocaleMessage = (pages: CmsPage[], languageId: string) => {
  const message: unknown = {};

  for (const page of pages) {
    message[page.url] = {};

    for (const element of page.elements) {
      const content = element.contents.find(translation => translation.cms_language_id === languageId)?.content;

      message[page.url][element.element] = content?.replaceAll('@', '&#64;');
    }
  }

  return message;
};
